import React, { useState } from 'react'

import logger from '@/utils/logger'

import RPC from '@/client/rpc'
import type {
  LeaderboardHighlight,
  LeaderboardKey,
  LeaderboardTimeFrame,
} from '@/client/services/leaderboard'

import TextWithLines from '@/components/TextWithLines/TextWithLines'
import { useToaster } from '@/components/Toast/useToaster'

export default function useLeaderboardHighlight({
  keys,
  timeFrames,
  userId,
}: {
  keys: LeaderboardKey[]
  timeFrames: LeaderboardTimeFrame[]
  userId: number
}): LeaderboardHighlight | null {
  const toast = useToaster()
  const [leaderboardHighlight, setLeaderboardHighlight] = useState<LeaderboardHighlight | null>(
    null
  )
  React.useEffect(
    () => {
      RPC.UNSAFE_getLeaderboardHighlight({ keys, timeFrames, userId })
        .then(res => setLeaderboardHighlight(res))
        .catch(err => {
          toast({
            title: (
              <TextWithLines text={`${err?.message ?? err}`} maxLines={Number.POSITIVE_INFINITY} />
            ),
            status: 'error',
          })
          logger.error('Error retrieving leaderboards', { err })
        })
    },
    // We only want this to run once.
    // oxlint-ignore-next-line react/exhaustive-deps
    []
  )

  return leaderboardHighlight
}
